<app-uni-page
  [parent]="this"
  pageTitle="End of Day: Print and Post Invoices"
  [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate"
/>

<ng-template #bodyTemplate>
  <div *ngIf="isPageReady" class="flex h-full flex-col">
    <uni-qb-health-banner></uni-qb-health-banner>
    <div class="qb-list-actions">
      <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-refresh" [disabled]="isBusy()" (click)="refresh()">
        <span>Refresh</span>
      </button>
      <p-checkbox
        class="ml-4 mt-3"
        [(ngModel)]="isSelectAllChecked"
        [binary]="true"
        [disabled]="isBusy() || invoiceActions.length === 0"
        (onChange)="toggleSelectAll($event.checked)"
        inputId="selectAllCheckbox"
      ></p-checkbox>
      <label for="selectAllCheckbox" class="ml-2 mt-4 text-sm">Select All</label>
      <button
        pButton
        type="button"
        class="p-button-raised p-button-sm ml-4"
        icon="pi pi-play"
        [disabled]="isBusy() || invoiceActions.length === 0"
        (click)="processSelectedInvoices()"
      >
        <span>Process Selected</span>
      </button>
      <span class="ml-4 mt-4 text-sm font-medium">{{ summaryText }}</span>
    </div>
    <div class="qb-panel-title mx-4 my-2 shrink-0">Pending Invoices</div>
    <app-ag-grid [gridOptions]="gridOptions" [rowData]="invoiceActions" class="min-h-0 flex-1"></app-ag-grid>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" (click)="goBack()"><span>Go Back</span></button>
  </div>
</ng-template>
